// "Last checked with M-Pesa: <time> — <result>" — why a payout item is still pending.
// The provider's own answer (result code + status word) is shown as-is; the status is
// OUR mapped outcome (paid / failed / still pending), never inferred from the code.
import type { ProviderCheck } from '../api/paygateApi';

const STATUS_LABEL: Record<string, string> = {
  paid: 'confirmed paid',
  failed: 'confirmed failed',
  submitted: 'still pending',
};

export function lastProviderCheckText(connector: string, check?: ProviderCheck): string | null {
  if (!check || !check.checkedAt) return null;
  const who = connector === 'mpesa' ? 'M-Pesa' : 'the provider';
  const when = new Date(check.checkedAt).toLocaleString();
  const answer = [check.resultCode || 'no result code', check.detail].filter(Boolean).join(' · ');
  const outcome = STATUS_LABEL[check.status] ?? check.status;
  return `Last checked with ${who}: ${when} — ${answer} (${outcome})`;
}
